import { Card as CardInterface, CardColor, CardType } from '@/types/card';

/**
 * カードクラス
 * カードの比較ロジックを実装
 */
export class Card implements CardInterface {
  constructor(
    public id: string,
    public color: CardColor,
    public type: CardType,
    public value?: number
  ) {}

  /**
   * 指定されたカードの上にこのカードをプレイできるか判定
   * @param topCard 捨て札の一番上のカード
   * @param declaredColor ワイルドカードで宣言された色
   * @returns プレイ可能ならtrue
   */
  canPlayOn(topCard: Card, declaredColor?: CardColor): boolean {
    // ワイルドカードは常にプレイ可能
    if (this.type === CardType.WILD || this.type === CardType.WILD_DRAW_FOUR) {
      return true;
    }

    // 有効な色を判定（宣言された色 or トップカードの色）
    const activeColor = declaredColor || topCard.color;

    // 色が一致
    if (this.color === activeColor) {
      return true;
    }

    // タイプが一致（Skip on Skip, Reverse on Reverseなど）
    if (this.type === topCard.type && this.type !== CardType.NUMBER) {
      return true;
    }

    // 数字カードで値が一致
    if (
      this.type === CardType.NUMBER &&
      topCard.type === CardType.NUMBER &&
      this.value === topCard.value
    ) {
      return true;
    }

    return false;
  }

  /**
   * カードの文字列表現
   */
  toString(): string {
    if (this.type === CardType.NUMBER) {
      return `${this.color} ${this.value}`;
    }
    return `${this.color} ${this.type}`;
  }

  /**
   * カードのJSON表現
   */
  toJSON(): CardInterface {
    return {
      id: this.id,
      color: this.color,
      type: this.type,
      value: this.value
    };
  }
}

/**
 * ユニークIDを生成
 */
export function generateCardId(): string {
  return `card-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
}
